import { tiposDocumento } from "@/config/constants";
import { searchQuery } from "@/utils";

export default {
  // Estado del loader
  // Inicialmente mostramos el loader
  // luego de que carga la primera vista
  // lo quitamos
  tcode: "",
  adobeTargetExperience: null,
  contratacionFinalizada: false,
  contratosFirmados: false,
  error: {},
  isLoading: false,
  loaderTitle: null,
  loaderText: null,
  isTermsVisible: false,
  notificationToast: {
    // [info, success, alert]
    type: "",
    message: ""
  },
  route: null,
  circuito: _BBVA_MOTOR || "ofertaPersonales",
  sucursales: [],
  mockPaquetes: null,
  errorVeridas: "",
  contadorLlamadosMerlin: 0,
  isBTD3: false,
  dataAuthASO: {
    tsec: "",
    tsecExpiry: null
  },
  DVSIframeData: {
    urlXpressId: "",
    id: ""
  },
  dataVeridas: {
    key: "",
    response: {
      isValid: null
    },
    contracts: [],
    thanksVeridas: false
  },
  biometria: {
    aceptoTerminos: true,
    isDigital: false,
    isPresencial: null
  },
  sdk: {
    preload: false,
    isVisible: false,
    iframe: null
  },
  renaperCalled: false,
  consultaPayload: null,
  consulta: {
    nombre: "",
    apellido: "",
    nombres: "",
    tipoDocumento: "00",
    numeroDoc: "",
    nacionalidad: "80",
    sexo: "F",
    fechaNacimiento: "",
    email: "",
    destino: "0104",
    diaDebito: "1",
    celular: {
      area: searchQuery.hr_area || "",
      numero: searchQuery.hr_numero || "",
      normalizado: {
        area: "",
        caracteristica: "",
        nro: "",
        interno: "",
        valido: null
      },
      compania: ""
    },
    sucursal: "",
    captcha: "",
    leadGenId: "",
    completed: false
  },
  entrega: {
    selectDomicilio: "particular",
    sucursal: "",
    domicilioParticular: {
      calle: "",
      numero: "",
      piso: "",
      dpto: "",
      codigoPostal: "",
      localidad: "",
      provincia: "01",
      valido: null,
      searchEncontesa: false
    },
    otroDomicilio: {
      calle: "",
      numero: "",
      piso: "",
      dpto: "",
      codigoPostal: "",
      localidad: "",
      provincia: "01",
      valido: null,
      searchEncontesa: false
    },
    fecha: "",
    hora: "de 9 a 12 hs.",
    resumenDigital: true,
    resumenDigitalEmail: ""
  },
  esCliente: null,
  valid: false,
  simulacion: {
    resultado: {
      multiplazo: [{cantidadCuotas:0}],
      clientePrestamo: {
        prestamo: {
          montoTotal: 0,
          cantidadCuotas: 0,
          primerasCuotas: [{cuotaTotal:0},{cuotaTotal:0}]
        }
      },
      multiplazoObj: {cantidadCuotas: 60}
    }
  },
  confirmarRenaper: {
    expediente: ""
  },
  oferta: {
    monto: 0,
    plazo: "0",
    destino: "0104",
    diaDebito: "1"
  },
  consultaHipotecario: {
    valorPropiedad: "",
    montoSolicitado: "",
    ingresos: "",
    plazo: "30",
    destino: "1",
    cuentaSueldo: "",
    etapa: ""
  },
  forzarDNE: {},
  paso1: {
    estadoCivil: "5",
    conyuge: {
      nombre: "",
      apellido: "",
      tipoDocumento: tiposDocumento.DNI,
      numeroDoc: ""
    },
    cuil: "",
    lugarNacimiento: "",
    domicilioParticular: {
      calle: "",
      numero: "",
      piso: "",
      dpto: "",
      codigoPostal: "",
      localidad: "",
      provincia: "01",
      valido: null
    },
    searchEncontesa: false
  },
  paso2: {
    situacionLaboral: "001",
    actividad: "47",
    ocupacion: "07",
    ingresoNeto: "+120001"
  },
  paso3: {
    pep: "0",
    sujetoObligado: "0",
    actividadSujetoObligado: "",
    fatca: "0",
    actividad: ""
  },
  paso4: {
    isDigital: false,
    isPresencial: null,
    isPresencialVoluntario: false
  },
  paso5: {
    motivo: "",
    diaDebito: "1"
  },
  paso6: {
    usuario: "",
    claveDigital: ""
  },
  paso7: {
    deviceUdid: "",
    otp: "",
    otpValid: null,
    error: false
  },
  paso8: {
    firmaContrato: false
  },
  resumen: {
    aceptaSolicitud: false
  },
  respuestaContratacion: {},
  deviceId: "",
  deviceIdTimestamp: "",
  envioSms: {
    status: "",
    sms: {
      area: "",
      numero: "",
      mensaje: ""
    }
  },
  userIdTokenizado: "",
  envioMailPH: null,
  fechaSistema: "",
  cotizacion: null,
  landingQrUrl: null
};
